import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=c78afada&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=js&"
export * from "./VideoBox.vue?vue&type=script&lang=js&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=c78afada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78afada",
  null
  
)

component.options.__file = "VideoBox.vue"
export default component.exports